import {isPAMMFundManagerAccount} from '../../common/utils/accounts'
import {Account, Maybe} from '../../graphql/types'

export const isNotNullAndNotPAMMFundManagerAccount = (account: Maybe<Account>): account is Account  =>
  account != null && !isPAMMFundManagerAccount(account)

export const isNotReadOnlyAccount = (account: Account): account is Account  =>
  'isReadOnly' in account && !Boolean(account.isReadOnly)
